// extracted by mini-css-extract-plugin
export default {"root":"Trigger_root__81A8n","chevron":"Trigger_chevron__R70Q0","active":"Trigger_active__E34rO","open":"Trigger_open__XTxx4"};